<template>
  <el-dialog :title="dialogTitle" :visible.sync="formVisible" width="600px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="100px">
      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入名称" />
      </el-form-item>
      <el-form-item label="状态">
        <el-switch v-model="form.enable" :active-value="'1'" :inactive-value="'0'"></el-switch>
        <span style="margin-left: 10px;">{{ form.enable === '1' ? '启用' : '禁用' }}</span>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()" :loading="isLoading">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import sysDataconstantApi from '@/api/config/sysDataconstant'

function initFormBean() {
  const formBean = {
    id: null,
    name: '',
    enable: '0'
  }
  return formBean
}

export default {
  props: {
    rowItem: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      form: initFormBean(),
      isLoading: false,
      formVisible: false,
      dialogTitle: '新增',
      formRules: {
        name: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }]
      },
      isRepSub: false,
      editIndex: null
    }
  },
  methods: {
    resetForm() {
      this.form = initFormBean()
      this.editIndex = null
    },
    handleCreate() {
      this.resetForm()
      this.dialogTitle = '新增'
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(scope) {
      this.resetForm()
      this.dialogTitle = '编辑'
      // 确保 enable 值正确转换为字符串类型
      let enableValue = scope.row.enable
      if (enableValue === undefined || enableValue === null) {
        enableValue = '1'
      } else {
        enableValue = String(enableValue)
      }
      this.form = {
        id: scope.row.id || null,
        name: scope.row.name || '',
        enable: enableValue
      }
      this.editIndex = scope.$index
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          this.isLoading = true

          if (!this.rowItem) {
            this.$common.showMsg('error', '数据未加载，请重试')
            this.isRepSub = false
            this.isLoading = false
            return
          }

          // 获取当前列表数据
          let list = this.rowItem.content ? JSON.parse(this.rowItem.content) : []
          
          if (this.editIndex !== null) {
            // 编辑模式：更新指定索引的数据
            list[this.editIndex] = {
              id: this.form.id,
              name: this.form.name,
              enable: this.form.enable
            }
          } else {
            // 新增模式：添加新数据
            const newItem = {
              id: Date.now(), // 使用时间戳作为临时ID
              name: this.form.name,
              enable: this.form.enable
            }
            list.push(newItem)
          }

          // 更新数据
          let params = JSON.parse(JSON.stringify(this.rowItem))
          params.content = JSON.stringify(list)
          
          sysDataconstantApi.update(params).then(() => {
            this.postCallback()
          }).catch(res => {
            this.isRepSub = false
            this.isLoading = false
            this.$common.showMsg('error', '操作失败，请重试')
          })
        }
      })
    },
    postCallback() {
      this.isRepSub = false
      this.isLoading = false
      this.$common.showMsg('success', '操作成功')
      this.formVisible = false
      this.$emit('created')
    }
  }
}
</script>

<style scoped>
::v-deep .el-select {
  width: 100%;
}
</style>

